(function($, Drupal, drupalSettings) {

  var firstLoadDS = true;

  Drupal.behaviors.data_sheets_list = {
    attach: function (context, settings) {

      // Filter updates.
      if ($('.view-datasheet-view .views-exposed-form select.form-select').length) {
        var selectedVal;

        // Track which element was just changed, keep them in sync.
        $('body').once('datasheets-list-select-change').on('change', '.view-datasheet-view .views-exposed-form select.form-select', function(){
          selectedVal = $('.view-datasheet-view .views-exposed-form select.form-select').val();
          $('.view-datasheet-view .views-exposed-form input[type="radio"][value="' + selectedVal + '"]').prop('checked', true);

          $('.view-datasheet-view .form-actions input[type="submit"]').trigger('click');
        });
        $('body').once('datasheets-list-radio-change').on('change', '.view-datasheet-view .views-exposed-form input[type="radio"]', function(){
          selectedVal = $('.view-datasheet-view .views-exposed-form input[type="radio"]:checked').val();
          $('.view-datasheet-view .views-exposed-form select.form-select').val(selectedVal);

          $('.view-datasheet-view .form-actions input[type="submit"]').trigger('click');
        });

        // Copy the querystring to categoryx on first load.
        if (firstLoadDS && $('.view-datasheet-view .views-exposed-form select.form-select').val() == 'All' &&
            $('.view-datasheet-view .views-exposed-form input[type="radio"]:checked').val() != 'All') {
          selectedVal = $('.view-datasheet-view .views-exposed-form input[type="radio"]:checked').val();
          $('.view-datasheet-view .views-exposed-form select.form-select').val(selectedVal);

          firstLoadDS = false;
        }

        // Convert mobile category filter to select2 list.
        var options = {};
        options.width = Drupal.webform.select2.options.widthInline;
        options = $.extend(options, Drupal.webform.select2.options);
        $('.view-datasheet-view .views-exposed-form select.form-select').chosen('destroy');
        $('.view-datasheet-view .views-exposed-form select.form-select').select2(options);
      }

    }
  }; // Drupal.behaviors.data_sheets_list

})(jQuery, Drupal, drupalSettings);
